












import { Component, Vue } from 'vue-property-decorator'
import detailRecord from './detailRecord.vue'
import {getRecordById, getSheetConfig} from '@/apis/sheet'
import {permissionE} from '@/views/sheet/widget/types'
import {SheetModule} from '@/store/modules/sheet'
@Component({
  components: {
    detailRecord
  }
})
export default class extends Vue {
  private priorityAuth = {} // 锁定权限
  private actionShow = false
  private hideRow = []
  private titleField = ''
  private workSheetObj: any = {}
  private getRecordList (type) {
    if (type === 'add') {
      this.$router.go(-1)
    }
  }
  private beforeRouteUpdate (to, from, next) {
    this.getRecord(to)
    next()
  }
  private async getRecord (route) {
    let {recordId, worksheetId, viewId} = route.params
    let res = await getSheetConfig({worksheetId, queryFieldType: 1, isQueryView: false, isNeedAuthority: true})
    this.workSheetObj = {}
    let obj = {}
    if (res.success) {
      (res.data.fields || []).forEach((item) => {
        obj[item.businessId] = item
      })
      res.data.fieldMap = obj
      this.workSheetObj = res.data
    }
    let detail = this.$refs.detailRecord as detailRecord
    await SheetModule.getsViewHideRow(viewId)
    this.hideRow = SheetModule.hideRowMap[viewId]
    getRecordById({worksheetId, id: recordId, viewId}).then((res1) => {
      if (res1.success) {
        let lockAuth = {}
        this.priorityAuth = {}
        if (res1.data.lockFieldAuthority) {
          res1.data.lockFieldAuthority.forEach(({businessId, authority}) => {
            lockAuth[businessId] = authority
          });
          let sheetFieldList = this.$store.state.sheet.sheetFieldList
          sheetFieldList.forEach((item) => {
            if (!lockAuth[item.businessId]) {
              lockAuth[item.businessId] = item.permissions && item.permissions.includes(permissionE.hidden) ? 'hidden' : 'visible'
            }
          })
        }
        this.priorityAuth = lockAuth
        detail.initForm(res1.data)
      }
    })
  }
  private mounted () {
    this.getRecord(this.$route)
  }
}
